import 'components/explorer/pane/index.css'
import * as React from 'react'
import type { Track } from 'types/track'
import Similarity from 'components/explorer/pane/similarity'
import Tabs from 'components/ui/tabs'
import Tab from 'components/ui/tabs/tab'
import type { ParentProps } from 'types/explorer'

type ContentProps = {
  simSearchProps?: ParentProps
  track?: Track
  playlistNum?: number
  list?: React.ReactNode
}
type TrackProps = {
  alias: string
  label: string
  isSimilarTrack?: boolean
  isAggregatedTrack?: boolean
  content?: ContentProps
}
type TabProps = {
  index: number
  onChange: (index: number) => void
  tabs: Array<TrackProps>
}

const TrackTabs = ({ tabs, ...rest }: TabProps): React.ReactNode => {
  return (
    <Tabs {...rest} className="Tabs--modal Tabs--no-margin">
      {tabs.map(tab => {
        const { content } = tab
        if (!content) return null
        const aggregatedURL = tab.isAggregatedTrack
          ? content.track?.public_download_url2
          : undefined
        return (
          // @ts-expect-error
          <Tab key={tab.label} alias={tab.alias} label={tab.label}>
            {tab.isSimilarTrack &&
            content.track?.id &&
            content.simSearchProps ? (
              <Similarity
                parentProps={content.simSearchProps}
                trackId={content.track.id}
                aggregatedTrackURL={aggregatedURL}
              />
            ) : (
              <>
                <div className="ExplorerPane_related-label">
                  <span>
                    {content.playlistNum}{' '}
                    <span>
                      {content.playlistNum === 1 ? 'playlist' : 'playlists'}
                    </span>
                  </span>
                </div>
                <div className="ExplorerPane_related-cont">{content.list}</div>
              </>
            )}
          </Tab>
        )
      })}
    </Tabs>
  )
}

export default TrackTabs
